module.exports = __webpack_public_path__ + "img/STRATEGY.6e44ebe2.svg";